import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bluetooth",
  "use": "icon-bluetooth-usage",
  "viewBox": "0 0 13 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 13 20\" id=\"icon-bluetooth\"><path d=\"M12.71 5.71 7 0H6v7.59L1.41 3 0 4.41 5.59 10 0 15.59 1.41 17 6 12.41V20h1l5.71-5.71L8.41 10zM8 3.83l1.88 1.88L8 7.59zm1.88 10.46L8 16.17v-3.76z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol